export default "__VITE_ASSET__xptOVRYQ__"